import React, { useMemo, useState } from 'react';
import Input from '../../../Input';
import ListItem from '../../../ListItem';
import { countries } from '../../lib/countries';
import CircleFlag from '../CircleFlag/CircleFlag';
import './CountrySelect.scss';
import Icon, { Icons } from '../../../Icon/Icon';
import { useNavigate } from 'react-router';

const SESSION_COUNTRY_KEY = 'selected-country';

const CountrySelect = () => {
	const [search, setSearch] = useState('');
	const navigate = useNavigate();

	const filtered = useMemo(() => {
		const q = search.toLowerCase();
		return countries.filter(
			c => c.name.toLowerCase().includes(q) || c.code.includes(q)
		);
	}, [search]);

	const onSelect = country => {
		sessionStorage.setItem(SESSION_COUNTRY_KEY, JSON.stringify(country));

		navigate(-1);
	};

	return (
		<div className='CountrySelect'>
			<Input
				placeholder='Search'
				value={search}
				onChange={e => setSearch(e.target.value)}
				className='CountrySelect-search FormBlock'
				prefix={<Icon type={Icons.SEARCH} width={20} height={20} />}
			/>

			<div className='CountrySelect-list'>
				{filtered.map(country => (
					<ListItem
						key={country.iso}
						icon={<CircleFlag countryCode={country.iso} size={32} />}
						title={country.code}
						description={country.name}
						onSelect={() => onSelect(country)}
						bottomSeparator
					/>
				))}
			</div>
		</div>
	);
};

export default CountrySelect;
